import { usePersistedState } from '@wyz/utils';
import { useApplicationContext } from '~/common/context';

/**
 * Persists the state under a key suffixed with the current user id, so that a
 * browser shared by several users never hands one of them the selection of
 * another one.
 */
export const useUserScopedState = <State>(
  namespace: string,
  defaultState: State,
) => {
  const { auth } = useApplicationContext();
  return usePersistedState<State>(`${namespace}.${auth.userId}`, defaultState);
};
